import React from 'react';
import { useParams } from 'react-router-dom';
import { BookComponent } from '../Book/BookComponent';
import { Book } from '../Book/types';
import { db } from '../firebase';

export const BookDetails = () => {
  const [book, setBook] = React.useState<Book>();
  const { id } = useParams<{ id: string }>();

  React.useEffect(() => {
    db.collection('books')
      .doc(id)
      .get()
      .then((resp) => {
        const doc = resp.data();
        if (doc) {
          const b: Book = {
            id: resp.id,
            name: doc.name,
            picture: doc.picture,
            available: doc.available,
            author: doc.author,
            genre: doc.genre,
          };
          setBook(b);
        }
      });
  }, [id]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {book ? <BookComponent book={book} isAdmin={false} /> : null}
    </div>
  );
};
